import { BlankEditorResult } from '@doltech/ui/lib/figma/BlankEditor/Result/BlankEditorResult';
import { QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { CollapseExpandPanel } from '@doltech/ui/lib/figma/CollapseExpandPanel/CollapseExpandPanel';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { QuestionV2 } from '@doltech/ui/lib/figma/Question/QuestionV2';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ResultSentenceCompleteQuestionInstance } from '../../model/Question/result-sentence-complete-question.store';
import { useTestResultStore } from '../../model/test-result.hook';
import { ExtraQuestionProps } from './BaseQuestion';

interface SentenceCompleteQuestionResultProps extends React.HTMLAttributes<HTMLDivElement> {
  data: ResultSentenceCompleteQuestionInstance & ExtraQuestionProps;
}

const QuestionLists = styled.div`
  display: grid;
  gap: 12px;
`;

export const Main = styled(Box)``;

const QuestionWrapper = styled.div`
  display: flex;
  .circle-text {
    display: inline-flex;
    margin-right: 12px;
    &.${QuestionDisplayMode.QUESTION_OPTION_CORRECT} {
      background-color: ${colorsV2.green100};
    }
    &.${QuestionDisplayMode.QUESTION_OPTION_MISSING} {
      background-color: ${colorsV2.black5};
      > span {
        color: ${colorsV2.black100};
      }
    }
    &.${QuestionDisplayMode.QUESTION_OPTION_WRONG} {
      background-color: ${colorsV2.red100};
    }
  }
`;

export const SentenceCompleteQuestionResult = observer(
  (props: SentenceCompleteQuestionResultProps) => {
    const { data } = props;
    const { sentences, no, index } = data;
    const [expand, setExpand] = React.useState(false);
    const store = useTestResultStore();

    const questionCollapsed = () => {
      const { id, editorValueJS, blanks } = sentences.find((it) =>
        it.blanks.map((blank) => blank.key).includes(index)
      );
      return (
        <QuestionWrapper>
          <QuestionV2 no={no} className="circle-text" />
          <BlankEditorResult
            key={id}
            value={editorValueJS}
            blanks={blanks}
            currentSelectedIndex={index}
            showQuestionNo={false}
            testMode={store.testMode}
          />
        </QuestionWrapper>
      );
    };

    const questionExpanded = () => {
      return (
        <QuestionLists className="question-lists">
          {sentences.map((sentence, idx) => {
            const { id, editorValueJS, blanks } = sentence;
            return (
              <QuestionWrapper key={id}>
                <QuestionV2 no={no - index + idx} />
                <BlankEditorResult
                  testMode={store.testMode}
                  value={editorValueJS}
                  blanks={blanks}
                  showQuestionNo={false}
                />
              </QuestionWrapper>
            );
          })}
        </QuestionLists>
      );
    };

    return (
      <Main
        as={CollapseExpandPanel}
        key={no}
        className="dol-question sentence-complete-answer"
        onToggleCollapse={() => setExpand((oldExpandValue) => !oldExpandValue)}
        expand={expand}
        collapsedSection={questionCollapsed()}
        expandedSection={questionExpanded()}
      />
    );
  }
);
